import { Styles, css, extractTransition, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  header: css`
    display: flex;
    width: 100%;
    gap: 8px;
  `,
  icon: css`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    margin-top: 2px;
    width: 36px;
    height: 36px;
  `,
  content: css`
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    justify-content: center;
  `,

  title: css`
    display: flex;
  `,
  titleDetails: css`
    display: flex;
    align-items: center;
    margin-left: auto;
    gap: 8px;
    line-height: 10px;
  `,
  titleDetailsButton: ({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    padding: 5px;
    width: 28px;
    height: 28px;
    border-radius: 6px;

    background-color: transparent;
    color: ${theme.colors.neutral.variant[60]};

    ${extractTransition((f) => f.cubic, { duration: 110, property: ['background-color', 'color'] })}

    &:hover {
      cursor: pointer;
      background-color: ${theme.colors.neutral.variant[10]};
      color: ${theme.colors.neutral.variant[80]};
    }

    svg {
      margin-left: -1px;
    }
  `,
  titleDetailsButtonActive: ({ theme }) => css`
    background-color: ${theme.colors.neutral.variant[10]};
    color: ${theme.colors.neutral.variant[80]};
  `,
  titleDetailsButtonMenu: css`
    z-index: 3;
  `,
  subtitle: css`
    display: flex;
    align-items: center;
    gap: 4px;

    height: 13px;
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
